/**
 * @generated SignedSource<<b6077b670e8e1d54c8940349c9239f2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUCategoryEditDeleteMutation$variables = {
  id: string;
};
export type PLUCategoryEditDeleteMutation$data = {
  readonly pluCategory: {
    readonly delete: {
      readonly pluCategories: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PLUCategoryItem_PLUCategory">;
      }>;
    } | null;
  } | null;
};
export type PLUCategoryEditDeleteMutation = {
  response: PLUCategoryEditDeleteMutation$data;
  variables: PLUCategoryEditDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategoryEditDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PLUCategoryDeletePayload",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PLUCategoryItem_PLUCategory"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUCategoryEditDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PLUCategoryDeletePayload",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f598a37ead745a34bbcf8552b7db6cea",
    "id": null,
    "metadata": {},
    "name": "PLUCategoryEditDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PLUCategoryEditDeleteMutation(\n  $id: ID!\n) {\n  pluCategory(id: $id) {\n    delete {\n      pluCategories {\n        id\n        ...PLUCategoryItem_PLUCategory\n      }\n    }\n  }\n}\n\nfragment PLUCategoryItem_PLUCategory on PLUCategory {\n  id\n  title\n  color\n}\n"
  }
};
})();

(node as any).hash = "470f89d221929bd4d9c0370469f7ec7e";

export default node;
